import { message } from "antd";
import { set_env, env_code, env, env_resource } from "@dt/util";

/**
 *  登录成功跳转
 * @param {string} redirectUrl
 */

export function loginSuccess(res) {
    let redirectUrl = res?.loginSystem;
    // 更新JSON对象的内容
    console.log("loginSuccess-res", res);
    console.log("env", env_resource);
    // 创建 BroadcastChannel 实例
    if ("undefined" != typeof BroadcastChannel) {
        const channel = new BroadcastChannel("userChannel");

        // 发送消息给其他页面
        channel.postMessage({
            type: "usernameChange",
            data: {
                userId: res?.userId,
                userName: res?.userName,
                masterUserName: res?.masterUserName,
                masterUserId: res?.masterUserId,
                role: res?.loginIdentity,
            },
        });

        // 关闭频道连接
        channel.close();
    }

    setTimeout(() => {
        if (redirectUrl) {
            if (redirectUrl.startsWith("http:")) {
                redirectUrl.replace("http:", "https:");
            }
            if (!redirectUrl.includes("formLogin")) {
                if (redirectUrl.indexOf("?") === -1) {
                    redirectUrl = redirectUrl + "?formLogin=true";
                } else {
                    redirectUrl = redirectUrl + "&formLogin=true";
                }
            }
            window.location = redirectUrl;
        } else {
            message.warn("跳转链接为空,无法重定向！");
        }
    }, 100);
}
